<template>
  <div class="pa-4">
    <RichText
      v-model="store.plan.ownership_responsibility"
      label="4.1 Ownership & Responsibility"
      class="mb-4"
      required
      :readonly="readonly"
    />
    <RichText
      v-model="store.plan.asset_class_description"
      label="4.2 Asset Class & Description"
      class="mb-4"
      required
      :readonly="readonly"
    />
    <RichText
      v-model="store.plan.selection_procurement"
      label="4.3 Selection & Procurement"
      class="mb-4"
      required
      :readonly="readonly"
    />
    <RichText
      v-model="store.plan.risk_register"
      label="4.4 Risk Register"
      class="mb-4"
      required
      :readonly="readonly"
    />
    <RiskRegisterLinkTable
      class="mb-4"
      :readonly="readonly"
      @delete="emit('delete', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import RichText from "@/components/base/inputs/RichText.vue";
import { useAMPStore } from "@/store/asset-management-plan";
import RiskRegisterLinkTable from "../links/RiskRegisterLinkTable.vue";
import { Deleteable } from "@/classes/asset-management-plan";

const props = defineProps<{
  readonly: boolean;
}>();

const emit = defineEmits<{
  delete: [item: Deleteable];
}>();

const store = useAMPStore();
</script>
